module.exports = __webpack_public_path__ + "navigation.svg?1881540905501053a47c27d8c75006b0";